export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of clinical charting and meal planning for complex cases. All those protocols looked impossible to organize. After day 5 with The Vault, I could structure my first complete consultation without stress. By week 3, I was managing a full roster of patients with total confidence. This system is a complete game-changer for my private practice.',
    name: 'Sarah M.',
    location: 'Boston · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/35e3091f-7174-4001-97e6-f66e4e13129f.jpg',
  },
  {
    quote:
      'I managed my clinic for 2 years feeling frustrated because I spent 4 hours every night doing paperwork. I tried expensive software for 6 months with no real workflow. The Sigma Smart method actually works. I am now using the modular meal planning system and saving 15 hours a week. It is pure professional freedom.',
    name: 'Jennifer L.',
    location: 'Vancouver · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7797296f-3649-41af-9bab-9a4822b50d6e.jpg',
  },
  {
    quote:
      'I was afraid I was not “clinical enough” to manage private patients. The Nutritionist’s Vault proved me wrong. The visual method makes everything so clear. I felt confident from DAY ONE, which kept me motivated to grow my brand. I recommend it to every nutritionist I know.',
    name: 'Robert D.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/96e6bc1b-07ac-49ad-9ff3-a9ece3d68631.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The intake forms live on my desk now. I assess patients on Monday and I already know their nutritional diagnosis before they leave. I manage 15 patients a week confidently now.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/4052c7e9-14ba-4414-8154-2f797821f774.jpg',
  },
  {
    quote:
      'The Meal Planning System did it in three days. I had tried Excel spreadsheets for a year and always felt burnt out. Seeing the modular method explained visually finally made business sense.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/d3c91b22-9a3a-4e9f-aede-11aff9f08f2d.jpg',
  },
  {
    quote:
      'I bought it for the clinical protocols and stayed for the business scaling advice. My practice brand looks 10x more professional now. Worth far more than $19.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0da7d30b-99e6-406c-94b1-24f641be54c4.jpg',
  },
];
